<div class="p500-ui-form-field">
  <p500-ui-select-with-icon-field
    [ngModel]="selectedData"
    [data]="options"
    [readonly]="readonly"
    [label]="label"
    [required]="true"
    (ngModelChange)="handleChange($event)"
  >
  </p500-ui-select-with-icon-field>
  <div *ngIf="control.getError('customValidate')" class="err-msg-tooltip">
    {{ control.getError('customValidate') }}
  </div>
  <div *ngIf="showWarning" class="text text-color--red p-1">
    <span i18n="@@common.warning">WARNING</span>:
    <p class="mb-10" i18n="@@currency.payment_method_warning">
      Currency changes in the default payment method cause discrepancies in financial data. Avoid them or perform them only after a billing
      period is over and new conversions or transactions haven’t appeared yet.
    </p>
  </div>
</div>
